export const ACCESS_TOKEN_KEY = "backoffice-access-token";
export const REFRESH_TOKEN_KEY = "backoffice-refresh-token";
export const ACCESS_EXPIRES_AT_KEY = "backoffice-access-expires-at";
export const REFRESH_EXPIRES_AT_KEY = "backoffice-refresh-expires-at";
export const LEGACY_AUTH_TOKEN_KEY = "backoffice-auth-token";

/**
 * Schedule a silent refresh this far before the access token expires.
 * 3 minutes leaves a safe buffer ahead of the 15-minute access-token TTL.
 */
export const ACCESS_TOKEN_REFRESH_LEAD_MS = 3 * 60 * 1000;
